import React from "react";
import styles from "./toggleDays.module.css";

const DAYS = [
  {
    id: 1,
    key: "Mon",
    label: "M",
  },
  {
    id: 2,
    key: "Tue",
    label: "T",
  },
  {
    id: 3,
    key: "Wed",
    label: "W",
  },
  {
    id: 4,
    key: "Thu",
    label: "T",
  },
  {
    id: 5,
    key: "Fri",
    label: "F",
  },
  {
    id: 6,
    key: "Sat",
    label: "S",
  },
  {
    id: 7,
    key: "Sun",
    label: "S",
  },
];

const ToggleDaysTrainer = ({ days, handleChangeDays, daysFromFacility }) => {
  return (
    <>
      <div className={styles.weekMain}>
        {DAYS?.map((item, index) => {
          return (
            <div
              key={index}
              className={
                days?.includes(item.key)
                  ? styles.weekDiv + " " + styles.weekDivActive
                  : styles.weekDiv + " " + styles.weekDisabledDays
              }
              value={item.key}
              onClick={() => {
                if (daysFromFacility?.includes(item?.key)) {
                  handleChangeDays(item?.key);
                }
              }}
            >
              {item?.label}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ToggleDaysTrainer;
